/* Returns a promise that will resolve on the next AnimationFrame */
export const nextFrame = () => {
  return new Promise((resolve, reject) => {
    requestAnimationFrame(() => {
      resolve({})
    })
  })
}
